// Every QR uploader on a page subscribes to the same Pusher channel (it is
// derived from the prism item / order id), so each one receives every phone
// upload. Only one of them may turn an upload into builder events, or the
// photos are added once per mounted uploader. The owner is whichever uploader
// most recently claimed it - i.e. the one the customer last opened.

let owners = [];

export function claimPusherEvents(id) {
  owners = [...owners.filter((owner) => owner !== id), id];
}

export function releasePusherEvents(id) {
  owners = owners.filter((owner) => owner !== id);
}

export function ownsPusherEvents(id) {
  return owners[owners.length - 1] === id;
}
